// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppointyForm_wrapper__5qmoi"};